/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import React, { useState } from "react";
import Table from "@mui/material/Table";

import {
  CircularProgress,
  TableCell,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useDownloadDocument } from "../../../hooks/useDownloadDocument";

export default function TaulaDocumentacio() {
  const { postDades } = useDownloadDocument();
  const [isLoading, setIsLoading] = useState(false);
  const [filaSeleccionada, setFilaSeleccionada] = useState(null);

  const dadesRequerimentString = localStorage.getItem("dadesRequeriment");
  const dadesRequeriment = JSON.parse(dadesRequerimentString);

  const documentsRow = dadesRequeriment.document || null;

  const DescarregarDocument = ({ idDocument }) => {
    const handleDescargarDocumento = async () => {
      setIsLoading(true);
      const dadesRequerimentString = localStorage.getItem("dadesRequeriment");
      const dadesRequeriment = JSON.parse(dadesRequerimentString);

      const nif = dadesRequeriment.nif;
      const numActuacio = dadesRequeriment.numActuacio;
      const numRegistreSortida = dadesRequeriment.numRegistreSortida;

      try {
        await postDades(
          {
            nif: nif,
            numActuacio: numActuacio,
            numRegistreSortida: numRegistreSortida,
          },
          idDocument.id
        );

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    return (
      <IconButton onClick={handleDescargarDocumento} title="Descarregar">
        <SaveAltIcon />
      </IconButton>
    );
  };

  const handleFilaClick = (id) => {
    setFilaSeleccionada(id);
  };
  
  return (
    <>
      {documentsRow && (
        <TableContainer component={Paper}>
          <Table sx={{ width: "90%" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="left"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  NOM DEL FITXER
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  DATA CREACIÓ
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  TIPUS DOCUMENT
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {documentsRow.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  onClick={() => handleFilaClick(row.id)}
                >
                  <TableCell align="left" sx={{ width: "35%" }}>
                    {row.descripcioDocument}
                  </TableCell>
                  <TableCell align="left" sx={{ width: "35%" }}>
                    {new Date(row.dataCreacio).toLocaleDateString()}
                  </TableCell>
                  <TableCell align="left" sx={{ width: "35%" }}>
                    {row.tipusDocument}
                  </TableCell>
                  {filaSeleccionada === row.id && isLoading ? (
                    <TableCell colSpan={4} align="center">
                      <CircularProgress />
                    </TableCell>
                  ) : (
                    <>
                      <TableCell align="left" sx={{ width: "1%" }}>
                        <DescarregarDocument idDocument={row} />
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
